import type { CSSProperties } from 'react';

import { useIntl } from 'react-intl';

import { wacToken } from '@/libraries/design/foundations';

import { messages } from './estimate-disclaimer.messages';

/**
 * Reusable non-binding-estimate disclaimer copy.
 *
 * Used on both the Estimate and Summary steps below the bottom action
 * row per Figma node 1103:32365. Fine-print typography (Charlie Text
 * Regular 12/18), primary-black, center-aligned, capped at ~768px wide
 * so it wraps consistently regardless of container width.
 *
 * The wrapping container adds 20px of top padding so the disclaimer
 * sits exactly 20px below the Back / Copy URL to share row per Figma.
 */
export const EstimateDisclaimer = () => {
	const intl = useIntl();

	return (
		<div style={wrapperStyle} data-testid="estimate-disclaimer">
			<p style={copyStyle}>{intl.formatMessage(messages.disclaimer)}</p>
		</div>
	);
};

// Full-width centering wrapper with 20px top padding (the gap from the
// Copy URL to share row above per Figma node 1103:32365).
const wrapperStyle: CSSProperties = {
	display: 'flex',
	justifyContent: 'center',
	paddingBlockStart: '20px',
};

// Fine-print typography — Charlie Text Regular 12/18, primary-black,
// center-aligned, max-width 768px so the line-length stays comfortable
// regardless of container width.
const copyStyle: CSSProperties = {
	margin: 0,
	fontFamily: wacToken('font.charlie.text'),
	fontSize: '12px',
	lineHeight: '18px',
	fontWeight: 400,
	color: wacToken('color.neutral.light1100'),
	textAlign: 'center',
	maxWidth: '768px',
};
